import React from "react";

const Prev = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="-0.5"
        y="0.5"
        width="54"
        height="54"
        rx="27"
        transform="matrix(-1 0 0 1 54.5 0.5)"
        fill="white"
      />
      <rect
        x="-0.5"
        y="0.5"
        width="54"
        height="54"
        rx="27"
        transform="matrix(-1 0 0 1 54.5 0.5)"
        stroke="#004D90"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27 21.9395L21.4697 27.4698V28.5304L27 34.0608L28.0607 33.0001L23.8107 28.7501H34.75V27.2501H23.8107L28.0607 23.0001L27 21.9395Z"
        fill="#004D90"
      />
    </svg>
  );
};

export default Prev;
